import React from 'react';
import { useLocation } from 'react-router-dom';
import { useSiteContent } from '../../context/SiteContentContext';

function upsertHeadElement(tagName, selector, applyAttributes) {
  let element = document.head.querySelector(selector);

  if (!element) {
    element = document.createElement(tagName);
    document.head.appendChild(element);
  }

  applyAttributes(element);
}

function setMetaByName(name, content) {
  upsertHeadElement('meta', `meta[name="${name}"]`, (element) => {
    element.setAttribute('name', name);
    element.setAttribute('content', content);
  });
}

function setMetaByProperty(property, content) {
  upsertHeadElement('meta', `meta[property="${property}"]`, (element) => {
    element.setAttribute('property', property);
    element.setAttribute('content', content);
  });
}

function setCanonicalUrl(url) {
  upsertHeadElement('link', 'link[rel="canonical"]', (element) => {
    element.setAttribute('rel', 'canonical');
    element.setAttribute('href', url);
  });
}

export function Seo({ page, title, description, image, noIndex = false }) {
  const location = useLocation();
  const { siteContent } = useSiteContent();

  const pageTitle = title || page?.seo?.title || siteContent.siteSettings.siteName;
  const pageDescription = description || page?.seo?.description || siteContent.siteSettings.footer.summary;
  const pageImage = image || page?.hero?.media?.poster || page?.hero?.media?.src || siteContent.siteSettings.defaultSeoImage;
  const canonicalUrl = `${siteContent.siteSettings.siteUrl}${location.pathname}`;

  React.useEffect(() => {
    document.documentElement.lang = 'en';
    document.title = pageTitle;

    setMetaByName(
      'robots',
      noIndex ? 'noindex, nofollow' : 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1',
    );
    setMetaByName('description', pageDescription);
    setCanonicalUrl(canonicalUrl);
    setMetaByProperty('og:site_name', siteContent.siteSettings.siteName);
    setMetaByProperty('og:title', pageTitle);
    setMetaByProperty('og:description', pageDescription);
    setMetaByProperty('og:type', 'website');
    setMetaByProperty('og:url', canonicalUrl);
    setMetaByProperty('og:image', pageImage);
    setMetaByName('twitter:card', 'summary_large_image');
    setMetaByName('twitter:title', pageTitle);
    setMetaByName('twitter:description', pageDescription);
    setMetaByName('twitter:image', pageImage);
  }, [canonicalUrl, noIndex, pageDescription, pageImage, pageTitle, siteContent.siteSettings.siteName]);

  return null;
}
